<template>
    <div>
        <template v-if="!loading">
            <div class="row">
                <b-progress :value="progress" class="w-100 mb-2"></b-progress>
            </div>

            <b-form @submit="createMember($event)">
                <div class="row" ref="formTop">
                    <b-card v-if="stage == 'name'" class="col-12 px-0">
                        <b-card-title title-tag="h5" title="Details"></b-card-title>
                        <b-card-sub-title v-if="errorMsg.creation" sub-title-tag="div">
                            <span class="text-danger">{{ errorMsg.creation }}</span>
                        </b-card-sub-title>
                        <b-card-body class="px-0">
                            <b-form-group label="Prefix" label-for="prefix">
                                <b-form-input id="prefix" v-model="member.prefix"
                                    placeholder="Mr, Mrs, Miss, etc."></b-form-input>
                            </b-form-group>
                            <b-form-group label="First Name" label-for="firstName">
                                <b-form-input id="firstName" v-model="member.forename"
                                    :state="Boolean((member.forename && member.forename.length > 1))"></b-form-input>
                                <div v-if="errorMsg.forename" class="invalid-feedback d-block">{{ errorMsg.forename }}</div>
                            </b-form-group>
                            <b-form-group label="Surname" label-for="surname">
                                <b-form-input id="surname" v-model="member.surname"
                                    :state="Boolean((member.surname && member.surname.length > 1))"></b-form-input>
                                <div v-if="errorMsg.surname" class="invalid-feedback d-block">{{ errorMsg.surname }}</div>
                            </b-form-group>
                            <b-form-group label="Date of Birth" label-for="dob">
                                <b-form-input type="date" show-decade-nav id="dob" v-model="member.dob"
                                    :state="Boolean(member.dob && member.dob.length > 2)"></b-form-input>
                                <div v-if="errorMsg.dob" class="invalid-feedback d-block">{{ errorMsg.dob }}</div>
                            </b-form-group>
                            <b-form-group label="Email Address" label-for="email">
                                <b-form-input if="email" type="email" v-model="member.email"
                                    :state="Boolean(member.email) && validateEmail(member.email) && !errorMsg.email" @keyup.enter.prevent="nextStage('contact')"></b-form-input>
                                <div v-if="errorMsg.email" class="invalid-feedback d-block">{{ errorMsg.email }}</div>
                            </b-form-group>
                            <b-form-group label="Email Address Confirm" label-for="email">
                                <b-form-input if="email" type="email" v-model="email_confirm"
                                    :state="Boolean(member.email) && validateEmail(member.email) && !errorMsg.email" @keyup.enter.prevent="nextStage('contact')"></b-form-input>
                                <div v-if="errorMsg.email" class="invalid-feedback d-block">{{ errorMsg.email }}</div>
                            </b-form-group>
                            <b-form-group label="Phone Number" label-for="phone">
                                <b-form-input id="phone" type="tel" v-model="member.phone"
                                    @keyup.enter.prevent="nextStage('contact')"></b-form-input>
                            </b-form-group>
                        </b-card-body>
                        <template v-slot:footer>
                            <div class="text-right">
                                <b-button :disabled="blocker" type="submit" variant="primary" @click="nextStage('contact')">Next</b-button>
                            </div>
                        </template>
                    </b-card>

                    <b-card v-if="stage == 'contact'" class="col-12 px-0">
                        <b-card-title title-tag="h5" title="Contact Details"></b-card-title>
                        <b-card-body class="px-0">
                            <b-form-group label="Address Line 1" label-for="address_1">
                                <b-form-input id="address_1" v-model="member.address_1" placeholder="Unit 8 Winston Ave"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Address Line 2" label-for="address_2">
                                <b-form-input id="address_2" v-model="member.address_2"></b-form-input>
                            </b-form-group>
                            <b-form-group label="City" label-for="city">
                                <b-form-input id="city" v-model="member.city" placeholder="Croft"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Region" label-for="region">
                                <b-form-input id="region" v-model="member.region" placeholder="Leicestershire"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Postcode" label-for="postcode">
                                <b-form-input id="postcode" v-model="member.postcode" @keyup.enter.prevent="nextStage('ice')"></b-form-input>
                            </b-form-group>
                        </b-card-body>
                        <template v-slot:footer>
                            <div class="text-right">
                                <b-button :disabled="blocker" type="button" @click="prevStage('name')">Go Back</b-button>
                                <b-button :disabled="blocker" type="button" variant="primary" @click="nextStage('ice')">Next</b-button>
                            </div>
                        </template>
                    </b-card>

                    <b-card v-if="stage == 'ice'" class="col-12 px-0">
                        <b-card-title title-tag="h5" title="In Case Of Emergency Details"></b-card-title>
                        <b-card-body class="px-0">
                            <b-form-group label="ICE Name" label-for="ice_name">
                                <b-form-input id="ice_name" v-model="member.ice_name"></b-form-input>
                            </b-form-group>
                            <b-form-group label="ICE Number" label-for="ice_number">
                                <b-form-input type="tel" id="ice_number" v-model="member.ice_number"></b-form-input>
                            </b-form-group>
                            <b-form-group label="ICE Relation" label-for="ice_relation">
                                <b-form-input id="ice_relation" v-model="member.ice_relation" placeholder="Mother, Father, Husband, Wife etc.." @keyup.enter.prevent="nextStage('medical')"></b-form-input>
                            </b-form-group>
                        </b-card-body>
                        <template v-slot:footer>
                            <div class="text-right">
                                <b-button :disabled="blocker" type="button" @click="prevStage('contact')">Go Back</b-button>
                                <b-button :disabled="blocker" type="button" variant="primary" @click="nextStage('medical')">Next</b-button>
                            </div>
                        </template>
                    </b-card>

                    <b-card v-if="stage == 'medical'" class="col-12 px-0">
                        <b-card-title title-tag="h5" title="Medical Conditions"></b-card-title>
                        <b-card-body class="px-0">
                            <b-form-checkbox v-model="conditions" switch>Do you have any medical conditions that we may need to be aware of in an emergency?</b-form-checkbox>
                            <b-form-group label="Conditions" label-for="conditions">
                                <b-form-textarea id="conditions" v-model="member.ice_notes" rows="5" :disabled="! conditions"></b-form-textarea>
                            </b-form-group>
                        </b-card-body>
                        <template v-slot:footer>
                            <div class="text-right">
                                <b-button :disabled="blocker" type="button" @click="prevStage('ice')">Go Back</b-button>
                                <b-button :disabled="blocker" type="submit" variant="primary" @click="createMember($event)">Register</b-button>
                            </div>
                        </template>
                    </b-card>

                    <b-card v-if="stage == 'uploading'" class="col-12 px-0">
                        <b-card-title title-tag="h5" title="Uploading"></b-card-title>
                        <b-card-body class="px-0 text-center">
                            <p>Running checks and uploading data.</p>
                            <p>Please wait...</p>
                            <div style="font-size: 14px;">
                                <i class="fas fa-circle-notch fa-spin fa-fw fa-3x"></i>
                            </div>
                        </b-card-body>
                    </b-card>

                    <b-card v-if="stage == 'success'" class="col-12 px-0">
                        <b-card-title title-tag="h5" title="Success"></b-card-title>
                        <b-card-body class="px-0 text-center">
                            <p>Member Registered</p>
                            <div class="mb-4">
                                <i class="fas fa-check-circle text-success fa-3x fa-fw"></i>
                            </div>
                            <p>Please check your email at {{ member.email }} to verify your email address.<br />
                                This email can take up to 5 min to come through.</p>
                            <p>Do be sure to check your spam mail if your email hasn't come through.</p>
                        </b-card-body>
                    </b-card>
                </div>
            </b-form>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            stage: 'name',
            progress: 0,
            errorMsg: {
                forename: null,
                surname: null,
                dob: null,
                phone: null,
                email: null,
                creation: null,
            },
            member: {
                prefix: null,
                forename: null,
                surname: null,
                dob: null,
                email: null,
                phone: null,
                address_1: null,
                address_2: null,
                city: null,
                region: null,
                postcode: null,
                ice_name: null,
                ice_number: null,
                ice_relation: null,
                ice_notes: null,
            },
            email_confirm: null,
            conditions: false,
            blocker: false,
        }
    },
    watch: {
        stage: function (newStage, oldStage) {
            console.info('Stage Changed: ' + oldStage + ' -> ' + newStage);
        }
    },
    methods: {
        createMember(e) {
            e.preventDefault();
            this.debounce();
            this.progress = this.progress + 5;
            this.stage = 'uploading';
            if (this.validateData()) {
                this.progress = this.progress + 5;
                if (this.emailCheck()) {
                    
                } else {
                    this.progress = 0;
                    this.stage = 'name';
                    this.$refs.formTop.scrollIntoView({
                        alignToTop: true,
                        behavior: "smooth",
                    });
                }
            } else {
                console.log('Validation Failed');
                this.progress = 0;
                this.stage = 'name';
                this.$refs.formTop.scrollIntoView({
                        alignToTop: true,
                        behavior: "smooth",
                    });
            }
        },
        uploadMember() {
            console.log('Starting Member Creation');
            this.progress = this.progress + 5;
            axios.post(this.$routes.route('member.store'), this.member)
                .then(response => {
                    console.log('Resule: ' + response);
                    this.progress = this.progress + 10;
                    if (response.data.status === 'error') {
                        this.progress = 0;
                        this.stage = 'name';
                        this.errorMsg.creation = response.data.message;
                        this.$refs.formTop.scrollIntoView({
                            alignToTop: true,
                            behavior: "smooth",
                        });
                    } else {
                        // this.$router.push({ name: 'publicRegister.success' });
                        this.progress = 100;
                        this.stage = 'success';
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        emailCheck() {
            this.errorMsg.email = null;
            axios.post(this.$routes.route('publicRegister.emailCheck'), {
                email: this.member.email
            })
                .then((response) => {
                    if (response.data.status === 'error') {
                        this.errorMsg.email = response.data.message;
                        return false;
                    } else {
                        console.log('Email is good');
                        this.errorMsg.email = null;
                        this.uploadMember();
                        return true;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        validateData() {
            var valid = true;
            if (!this.member.forename || this.member.forename.length < 2) {
                this.errorMsg.forename = 'Please enter a forename';
                valid = false;
            } else {
                this.errorMsg.forename = null;
            }

            if (!this.member.surname || this.member.surname.length < 2) {
                this.errorMsg.surname = 'Please enter a surname';
                valid = false;
            } else {
                this.errorMsg.surname = null;
            }

            if (!this.member.dob || this.member.dob.length < 2) {
                this.errorMsg.dob = 'Please enter a date of birth';
                valid = false;
            } else {
                this.errorMsg.dob = null;
            }

            if (!this.member.email || this.member.email.length < 2 || !this.validateEmail(this.member.email)) {
                this.errorMsg.email = 'Please enter a valid email address';
                valid = false;
            } else {
                this.errorMsg.email = null;
            }

            if (this.member.email !== this.email_confirm) {
                this.errorMsg.email = 'Emails do not match';
                valid = false;
            } else {
                this.errorMsg.email = null;
            }

            return valid;
        },
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        nextStage(stage) {
            this.debounce();
            console.info('Next Stage: ' + stage);
            this.progress = this.progress + 25;
            this.stage = stage;
        },
        prevStage(stage) {
            this.debounce();
            console.info('Prev Stage: ' + stage);
            this.progress = this.progress - 25;
            this.stage = stage;
        },
        debounce() {
            if (this.blocker) {
                return;
            }
            this.blocker = true;
            setTimeout(() => {
                this.blocker = false;
            }, 100);
        },
    },
    mounted() { },
}
</script>